export function StatusBadge({ status }: { status: string }) {
  const cls = status === 'ready' ? 'ok' : status === 'failed' ? 'bad' : status === 'new' ? '' : 'warn';
  return <span className={`badge ${cls}`}>{status}</span>;
}
